<template>
  <div class="no-messages">
    <div>
      <h3>Start chatting with the {{ props.type === 'creator' ? 'brand' : 'creator' }}</h3>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    type: {
      type: String,
      required: true
    },
  });
</script>

<style lang="scss">

  .no-messages {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    padding: 0 16px;
    color: var(--black-90);
    max-width: 600px;
    margin: 0 auto;

    h3 {
        font: var(--medium-24);
        margin-bottom: 16px;
    }
  }
</style>